/**
 * Phase 1: Recent Activity Hook
 * 
 * Simplified using React Query for centralized fetching and deduplication.
 * Eliminates complex mount/unmount state management and StrictMode handling.
 */

import { useRecentActivityQuery } from '../services/queryService';

/**
 * Hook that provides recent activity data for dashboard
 * 
 * Phase 1: Migrated to use centralized query service with React Query
 * for automatic deduplication and caching. Maintains backward compatibility.
 * 
 * @returns {Object} Recent activity data and loading states
 */
export const useRecentActivity = () => {
  const { 
    data: recentActivity, 
    isLoading, 
    isError,
    error,
    refetch 
  } = useRecentActivityQuery();


  // Backward compatible interface
  return {
    recentActivity: recentActivity || [],
    isLoading,
    isError,
    error: isError ? 'Failed to load recent activity' : null,
    hasData: !isLoading && !isError && recentActivity?.length > 0,
    refetch
  };
};
